import { BaseModalInterface } from './base-modal.interface';

export interface MapModalInterface extends BaseModalInterface {
  imageUrl: string;
  imageAltText: string;
}
